import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import { Flex } from 'styled-system/jsx';

const CameraLoading = () => {
  return (
    <Flex
      height="100lvh"
      width="100%"
      zIndex="toast"
      position="fixed"
      left="50%"
      top="50%"
      transform="translate(-50%, -50%)"
      justifyContent="center"
      alignItems="center"
      backgroundColor="rgba(0, 0, 0, 0.4)"
      backdropFilter="blur(12px)"
    >
      <CircularLoading color="colors.purple-primary" />
    </Flex>
  );
};

export default CameraLoading;
